import { Flex, Typography } from 'antd';
import { AuditType } from './audit-type';
import {
  BuildOutlined,
  BulbOutlined,
  DollarOutlined,
  GroupOutlined,
  MessageOutlined,
  SettingOutlined,
} from '@ant-design/icons';

export const AuditTypeStep = ({ type, handleValue }) => {
  const options = [
    {
      value: 'retention',
      title: 'Family Retention Intent',
      description: 'Assess likelihood of families returning next year and key retention factors',
      note: 'Best conducted 3-4 months before re-enrollment deadlines',
      Icon: GroupOutlined,
      iconBg: '#DBEAFE',
    },
    {
      value: 'interest',
      title: 'Program Interest Assessment',
      description: 'Evaluate interest in new programs, services, and academic offerings',
      note: 'Ideal for mid-year or when considering new program offerings',
      Icon: BulbOutlined,
      iconBg: '#DCFCE7',
    },
    {
      value: 'satisfaction',
      title: 'Communication Satisfaction',
      description: 'Review effectiveness of school communication and engagement methods',
      note: 'Most effective quarterly or after major communication changes',
      Icon: MessageOutlined,
      iconBg: '#F3E8FF',
    },
    {
      value: 'tuition',
      title: 'Tuition Value Perception',
      description: 'Understand family perspectives on tuition pricing and perceived value',
      note: 'Optimal timing before tuition announcements or mid-contract',
      Icon: DollarOutlined,
      iconBg: '#FED7AA',
    },
    {
      value: 'facilities',
      title: 'Facilities & Resources',
      description: 'Gather feedback on school facilities, resources, and infrastructure',
      note: 'Best after facility changes or during planning phases',
      Icon: BuildOutlined,
      iconBg: '#DBEAFE',
    },
    {
      value: 'custom',
      title: 'Custom Audit Type',
      description: 'AI will create a custom audit based on your specific description',
      note: 'Flexible timing based on your specific needs and objectives',
      Icon: SettingOutlined,
      iconBg: '#F3F4F6',
    },
  ];

  return (
    <div>
      <Typography.Title level={5}>Select Audit Type *</Typography.Title>
      <Typography.Text type="secondary">Choose from our predefined audit types or create a custom one</Typography.Text>
      <Flex vertical gap={16}>
        {options.map((item, idx) => (
          <AuditType
            key={idx}
            type={item}
            Icon={item.Icon}
            selected={type}
            onClick={() => handleValue('type', item.value)}
          />
        ))}
      </Flex>
    </div>
  );
};
